export const tokenAddresses = {
  EUL: "0x38C043856A109066d64a60c82e07848a1C58e7Dc",
  eUSD: "0x0000000000000000000000000000000000000000",
  rEUL: "0xCf623E50430CCb55214985F9C986a5Fa50aD7686",
  seUSD: "0x0000000000000000000000000000000000000000",
} as const
